const dateFormats = ["MM/DD/YYYY", "DD/MM/YYYY"];
module.exports = dateFormats;
